// Function to preprocess content to replace quotes & strikethrough with custom syntax
export const preprocessContent = (content: string) => {
  const transformedContent = content.replace(/(`[^`]+`)|“([^”]+)”|"([^"]+)"|~~([^~]+)~~/g, (match, code, quoted1, quoted2, strikethrough) => {
    if (code) {
      return code;
    } else if (quoted1 || quoted2) {
      const quoteText = quoted1 || quoted2;
      return `<q>${quoteText}</q>`;
    } else if (strikethrough) {
      return `<del>${strikethrough}</del>`;
    }
    return match; // No match found
  });

  return transformedContent;
};
